import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { theme } from "../../theme"; // 🟢 KHÔI PHỤC THEME GỐC BẢO VỆ NAVBAR
import { 
    Box, Button, Container, Table, TableBody, TableCell, TableHead, TableRow, 
    TextField, Card, CardContent, Typography, Stack, Chip, TableContainer, 
    CircularProgress, IconButton, Grid
} from "@mui/material";
import { 
    AccountBalanceOutlined, AddCircleOutline, EditOutlined, 
    VisibilityOutlined, VisibilityOffOutlined, QrCode2Outlined,
    DeleteOutlined // <-- THÊM ICON XÓA
} from "@mui/icons-material";
import axios from "axios";
import swal from "sweetalert";
import { t } from "i18next";
import { useEffect, useState } from "react";

// ==========================================
// THEME CHUẨN KÈM FONT PLUS JAKARTA SANS
// ==========================================
const metronicTheme = createTheme({
    palette: {
        background: { default: "#F5F8FA", paper: "#FFFFFF" }, 
        text: { primary: "#181C32", secondary: "#7E8299" }, 
        primary: { main: "#1B84FF", light: "#F1FAFF" },
        success: { main: "#50CD89", light: "#E8FFF3" },
        danger: { main: "#F1416C", light: "#FFF5F8" },
        warning: { main: "#FFC700", light: "#FFF8DD" },
    },
    typography: { fontFamily: "'Plus Jakarta Sans', sans-serif" },
    components: {
        MuiCard: { styleOverrides: { root: { borderRadius: "12px", boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.03)", border: "1px solid #E4E6EF" } } },
        MuiTableCell: { styleOverrides: { root: { borderBottom: "1px solid #EFF2F5 !important", padding: "14px 12px", color: "#3F4254", fontSize: "0.85rem", fontFamily: "'Plus Jakarta Sans', sans-serif !important" } } },
        MuiButton: { styleOverrides: { root: { fontFamily: "'Plus Jakarta Sans', sans-serif", textTransform: 'none' } } }
    }
});

// Cấu hình axios gửi token
axios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("user");
        if (token) {
            config.headers["Authorization"] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

function BankAdmin() {
    const [bank, setBank] = useState();
    const [load, setLoad] = useState(true);
    const [isShow, setShow] = useState(false);
    const [profile, setProfile] = useState(JSON.parse(localStorage.getItem("profile")));
    const [bankItem, setBankItem] = useState();

    useEffect(() => {
        if (load === true) {
            axios.get(`${process.env.REACT_APP_API_URL}/auth/getbank`, {}).then((res) => {
                setBank(res.data.data);
                setLoad(false);
            }).catch(() => setLoad(false));
        }
    }, [load]);

    // HÀM XỬ LÝ THÊM NGÂN HÀNG MỚI
    const handleSubmit = (e) => {
        e.preventDefault();
        setLoad(true);
        const formData = {
            fullname: e.target.fullname.value,
            stk: e.target.stk.value,
            name_bank: e.target.name_bank.value,
            title: e.target.title.value,
            qr: e.target.qr.value
        };

        axios
            .post(`${process.env.REACT_APP_API_URL}/auth/newbank`, formData)
            .then((res) => {
                swal(t('success'), "Thêm ngân hàng thành công!", "success").then(() => {
                    window.location.reload();
                });
            })
            .catch((res) => {
                swal(t('error'), "Có lỗi xảy ra", "error");
                setLoad(false);
            });
    };

    // HÀM XỬ LÝ SỬA NGÂN HÀNG
    const handleSubmitBank = (e) => {
        e.preventDefault();
        setLoad(true);
        const formData = {
            id: bankItem._id,
            fullname: e.target.fullname.value,
            stk: e.target.stk.value,
            name_bank: e.target.name_bank.value,
            title: e.target.title.value,
            qr: e.target.qr.value
        };

        axios.post(`${process.env.REACT_APP_API_URL}/auth/editlistbank`, formData).then((res) => {
            swal(t('success'), "Cập nhật thành công!", "success").then(() => window.location.reload());
            setShow(false);
        }).catch(() => {
            swal(t("error"), "Có lỗi xảy ra", "error");
            setLoad(false);
        });
    };

    // HÀM XỬ LÝ XÓA NGÂN HÀNG (THÊM MỚI)
   const handleDeleteBank = (id, bankName) => {
        swal({
            title: "Xác nhận xóa?",
            text: `Bạn sắp xóa vĩnh viễn ngân hàng ${bankName}. Hành động này không thể hoàn tác!`,
            icon: "warning",
            buttons: ["Hủy", "Xóa"],
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                setLoad(true);
                
                // 🟢 SỬA axios.delete THÀNH axios.post Ở DÒNG DƯỚI NÀY:
                axios.post(`${process.env.REACT_APP_API_URL}/auth/deletebank/${id}`)
                    .then((res) => {
                        swal("Thành công!", "Đã xóa ngân hàng.", "success").then(() => {
                            window.location.reload();
                        });
                    })
                    .catch(() => {
                        swal("Lỗi!", "Có lỗi xảy ra khi xóa", "error");
                        setLoad(false);
                    });
            }
        });
    };

    // Style chung cho bảng
    const tableHeadSx = {
        color: "#A1A5B7 !important", fontWeight: "800 !important", fontSize: "0.75rem !important", 
        backgroundColor: "#FFFFFF !important", borderBottom: "2px solid #EFF2F5 !important",
        textTransform: "uppercase !important", whiteSpace: "nowrap"
    };

    // Style chung cho ô nhập liệu (TextField)
    const textFieldSx = {
        '& .MuiOutlinedInput-root': {
            borderRadius: '8px',
            backgroundColor: '#F9F9F9',
            height: '46px',
            '& fieldset': { borderColor: '#E4E6EF' },
            '&:hover fieldset': { borderColor: '#B5B5C3' },
            '&.Mui-focused fieldset': { borderColor: '#1B84FF', borderWidth: '1px' },
        },
        '& .MuiInputBase-input': { 
            height: '46px', padding: '0 14px', boxSizing: 'border-box',
            fontSize: '0.95rem', color: '#181C32', fontWeight: 600
        }
    };

    return (
        // 🟢 BỌC THEME GỐC Ở ĐÂY ĐỂ BẢO VỆ NAVBAR
        <ThemeProvider theme={theme}>
            <DashboardLayout>
                    
                    <ThemeProvider theme={metronicTheme}>
                        <style>{`
                            @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
                            .safe-bank-zone * { font-family: 'Plus Jakarta Sans', sans-serif !important; }
                        `}</style>

                        <Box className="safe-bank-zone" component="main" sx={{ flexGrow: 1, py: 4, backgroundColor: 'background.default', minHeight: 'calc(100vh - 70px)', position: 'relative' }}>
                            
                            {load && (
                                <Box sx={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(255,255,255,0.6)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', backdropFilter: 'blur(2px)' }}>
                                    <CircularProgress size={50} sx={{ color: '#1B84FF' }} />
                                </Box>
                            )}

                            <Container maxWidth="xl">
                                
                                {/* HEADER */}
                                <Box mb={4} display="flex" alignItems="center" gap={1.5}>
                                    <AccountBalanceOutlined sx={{ fontSize: '2.5rem', color: '#1B84FF' }} />
                                    <Box>
                                        <Typography variant="h4" fontWeight="800" color="#181C32">{t("setting_bank")}</Typography>
                                        <Typography variant="body2" color="text.secondary">Thiết lập các tài khoản ngân hàng nhận tiền của hệ thống</Typography>
                                    </Box>
                                </Box>

                                {/* FORM THÊM NGÂN HÀNG MỚI */}
                                <Card sx={{ mb: 4, backgroundColor: '#FFFFFF' }}>
                                    <CardContent sx={{ p: 4 }}>
                                        <Typography variant="subtitle1" fontWeight="800" color="#181C32" mb={3} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <AddCircleOutline color="primary" /> THÊM TÀI KHOẢN MỚI
                                        </Typography>
                                        
                                        <form onSubmit={handleSubmit}>
                                            <Grid container spacing={3}>
                                                <Grid item xs={12} sm={6} md={3}>
                                                    <Typography variant="caption" fontWeight="800" color="#7E8299" mb={1} display="block">{t("bank_name").toUpperCase()}</Typography>
                                                    <TextField fullWidth name="name_bank" id="name_bank" required placeholder="VD: Vietcombank..." sx={textFieldSx} />
                                                </Grid>
                                                <Grid item xs={12} sm={6} md={3}>
                                                    <Typography variant="caption" fontWeight="800" color="#7E8299" mb={1} display="block">{t("bank_number").toUpperCase()}</Typography>
                                                    <TextField fullWidth name="stk" id="stk" required placeholder="Nhập số tài khoản..." sx={textFieldSx} />
                                                </Grid>
                                                <Grid item xs={12} sm={6} md={3}>
                                                    <Typography variant="caption" fontWeight="800" color="#7E8299" mb={1} display="block">{t("bank_account").toUpperCase()}</Typography>
                                                    <TextField fullWidth name="fullname" id="fullname" required placeholder="Tên chủ tài khoản..." sx={textFieldSx} />
                                                </Grid>
                                                <Grid item xs={12} sm={6} md={3}>
                                                    <Typography variant="caption" fontWeight="800" color="#7E8299" mb={1} display="block">{t("content_bank").toUpperCase()}</Typography>
                                                    <TextField fullWidth name="title" id="title" placeholder="Ghi chú (nếu có)..." sx={textFieldSx} />
                                                </Grid>
                                                <Grid item xs={12} md={9}>
                                                    <Typography variant="caption" fontWeight="800" color="#7E8299" mb={1} display="flex" alignItems="center" gap={0.5}><QrCode2Outlined fontSize="small"/> LINK ẢNH QR CODE</Typography>
                                                    <TextField fullWidth name="qr" id="qr" placeholder="Nhập đường dẫn ảnh QR..." sx={textFieldSx} />
                                                </Grid>
                                                <Grid item xs={12} md={3} sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                                    <Button 
                                                        type="submit" 
                                                        variant="contained" 
                                                        color="primary" 
                                                        fullWidth 
                                                        sx={{ height: '46px', fontWeight: 800, borderRadius: '8px', boxShadow: 'none' }}
                                                    >
                                                        {t("add_new")}
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </form>
                                    </CardContent>
                                </Card>

                                {/* BẢNG DANH SÁCH NGÂN HÀNG */}
                                <Card sx={{ backgroundColor: '#FFFFFF' }}>
                                    <TableContainer sx={{ overflowX: 'auto' }}>
                                        <Table sx={{ minWidth: 1460 }}>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell sx={{...tableHeadSx, pl: 3}}>{t("bank_name")}</TableCell>
                                                    <TableCell sx={tableHeadSx}>{t("bank_number")}</TableCell>
                                                    <TableCell sx={tableHeadSx}>{t("bank_account")}</TableCell>
                                                    <TableCell sx={tableHeadSx}>{t("content_bank")}</TableCell>
                                                    <TableCell sx={tableHeadSx}>MÃ QR</TableCell>
                                                    <TableCell align="right" sx={{...tableHeadSx, pr: 3}}>{t("more")}</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {bank && bank.length > 0 ? (
                                                    bank.map((item) => (
                                                        <TableRow key={item._id} hover sx={{ verticalAlign: 'middle' }}>
                                                            <TableCell sx={{ pl: 3 }}>
                                                                <Typography variant="body2" fontWeight="800" color="#1B84FF">
                                                                    {item.name_bank}
                                                                </Typography>
                                                            </TableCell>
                                                            <TableCell sx={{ fontWeight: "700", color: "#181C32" }}>
                                                                {item.stk}
                                                            </TableCell>
                                                            <TableCell sx={{ fontWeight: "700", color: "#4B5675" }}>
                                                                {item.fullname}
                                                            </TableCell>
                                                            <TableCell sx={{ fontWeight: "600", color: "#7E8299", maxWidth: "200px" }}>
                                                                {item.title}
                                                            </TableCell>
                                                            <TableCell>
                                                                {item.qr ? <Chip icon={<QrCode2Outlined />} label="Đã có QR" size="small" sx={{ backgroundColor: '#E8FFF3', color: '#16A34A', fontWeight: 700 }} /> : <Typography variant="caption" color="text.secondary">Trống</Typography>}
                                                            </TableCell>
                                                            <TableCell align="right" sx={{ pr: 3 }}>
                                                                <Stack direction="row" spacing={1} justifyContent="flex-end">
                                                                    {/* NÚT ẨN/HIỆN */}
                                                                    <Button 
                                                                        variant="outlined" 
                                                                        size="small" 
                                                                        onClick={() => {
                                                                            setLoad(true);
                                                                            axios.post(`${process.env.REACT_APP_API_URL}/auth/editlistbank`, { id: item._id, isShow: !item.isShow })
                                                                                .then(() => setLoad(true))
                                                                                .catch(() => setLoad(false));
                                                                        }}
                                                                        sx={{ 
                                                                            fontWeight: 700, borderRadius: '6px', py: 0.5,
                                                                            color: item.isShow ? '#16A34A' : '#7E8299',
                                                                            borderColor: item.isShow ? '#16A34A' : '#E4E6EF',
                                                                            backgroundColor: item.isShow ? '#DCFCE7' : '#F5F8FA'
                                                                        }}
                                                                        startIcon={item.isShow ? <VisibilityOutlined fontSize="small"/> : <VisibilityOffOutlined fontSize="small"/>}
                                                                    >
                                                                        {item.isShow ? t("hide") : t("show")}
                                                                    </Button>

                                                                    {/* NÚT SỬA */}
                                                                    <IconButton 
                                                                        size="small" 
                                                                        onClick={() => {
                                                                            axios.get(`${process.env.REACT_APP_API_URL}/auth/bankall/${item._id}`)
                                                                                .then((res) => {
                                                                                    setBankItem(res.data.data);
                                                                                    setShow(true);
                                                                                })
                                                                                .catch(() => swal(t("error"), "", "error"));
                                                                        }}
                                                                        sx={{ color: '#1B84FF', backgroundColor: '#F1FAFF', borderRadius: '6px', '&:hover': { backgroundColor: '#1B84FF', color: '#FFF' } }}
                                                                    >
                                                                        <EditOutlined fontSize="small" />
                                                                    </IconButton>

                                                                    {/* NÚT XÓA */}
                                                                    <IconButton 
                                                                        size="small" 
                                                                        onClick={() => handleDeleteBank(item._id, item.name_bank)}
                                                                        sx={{ color: '#F1416C', backgroundColor: '#FFF5F8', borderRadius: '6px', '&:hover': { backgroundColor: '#F1416C', color: '#FFF' } }}
                                                                    >
                                                                        <DeleteOutlined fontSize="small" />
                                                                    </IconButton>

                                                                </Stack>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))
                                                ) : (
                                                    <TableRow>
                                                        <TableCell colSpan={6} align="center" sx={{ py: 6, color: '#A1A5B7', fontWeight: 700 }}>
                                                            {t("waiting")} (Chưa có dữ liệu)
                                                        </TableCell>
                                                    </TableRow>
                                                )}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Card>
                            </Container>
                        </Box>

                        {/* MODAL CHỈNH SỬA NGÂN HÀNG */}
                        {isShow && bankItem != null && (
                            <Box sx={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', backdropFilter: 'blur(3px)' }}>
                                <Card sx={{ width: '90%', maxWidth: '600px', p: 3 }}>
                                    <Typography variant="h6" fontWeight="800" mb={1} color="#181C32">
                                        {t("edit")} Tài Khoản Ngân Hàng
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" mb={3}>
                                        Đang sửa: <Typography component="span" fontWeight="800" color="#1B84FF">{bankItem.name_bank} - {bankItem.stk}</Typography>
                                    </Typography>
                                    
                                    <form onSubmit={handleSubmitBank}>
                                        <Grid container spacing={2.5}>
                                            <Grid item xs={12} sm={6}>
                                                <Typography variant="caption" fontWeight="800" color="text.secondary" sx={{ mb: 0.5, display: 'block', textTransform: 'uppercase' }}>{t("bank_name")}</Typography>
                                                <TextField name="name_bank" defaultValue={bankItem.name_bank} required sx={textFieldSx} fullWidth />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <Typography variant="caption" fontWeight="800" color="text.secondary" sx={{ mb: 0.5, display: 'block', textTransform: 'uppercase' }}>{t("bank_number")}</Typography>
                                                <TextField name="stk" defaultValue={bankItem.stk} required sx={textFieldSx} fullWidth />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <Typography variant="caption" fontWeight="800" color="text.secondary" sx={{ mb: 0.5, display: 'block', textTransform: 'uppercase' }}>{t("bank_account")}</Typography>
                                                <TextField name="fullname" defaultValue={bankItem.fullname} required sx={textFieldSx} fullWidth />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <Typography variant="caption" fontWeight="800" color="text.secondary" sx={{ mb: 0.5, display: 'block', textTransform: 'uppercase' }}>{t("content")}</Typography>
                                                <TextField name="title" defaultValue={bankItem.title} sx={textFieldSx} fullWidth />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Typography variant="caption" fontWeight="800" color="text.secondary" sx={{ mb: 0.5, display: 'block', textTransform: 'uppercase' }}>LINK MÃ QR</Typography>
                                                <TextField name="qr" defaultValue={bankItem.qr} sx={textFieldSx} fullWidth />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Stack direction="row" spacing={2} justifyContent="flex-end" mt={1}>
                                                    <Button variant="outlined" color="inherit" onClick={() => setShow(false)} sx={{ fontWeight: 800, px: 3, borderRadius: '8px' }}>
                                                        {t("close")}
                                                    </Button>
                                                    <Button variant="contained" color="primary" type="submit" sx={{ fontWeight: 800, px: 4, borderRadius: '8px', boxShadow: 'none' }}>
                                                        {t("submit")} (Lưu)
                                                    </Button>
                                                </Stack>
                                            </Grid>
                                        </Grid>
                                    </form>
                                </Card>
                            </Box>
                        )}

                    </ThemeProvider>
              
            </DashboardLayout>
        </ThemeProvider>
    );
}

export default BankAdmin;